import { CARD_CONTENT_OVERLAY_TABLES } from "@-/dev.improve.haniverse.lib.cards.card-content";

/** Actor tables determining study-card identity, schedule and review eligibility. */
export const STUDY_CARD_DATA_TABLES = [
  "fsrs_card",
  "user_card",
  "user",
  ...CARD_CONTENT_OVERLAY_TABLES,
] as const;
